<template>
  <v-container fluid grid-list-md class="pt-0">
    <v-card class="pa-2 grey lighten-4 mb-3 card-r pb-2 shadow-1">
      <v-toolbar class="primary mb-2 card-r pl-3 text-white">
        <router-link to="/packages"><v-icon class="text-white mr-3 left">arrow_left</v-icon></router-link>
        <div class="text-xs-left f-20">Edit Package</div>
      </v-toolbar>
      <v-layout wrap >
                      <v-flex xs12 lg4><v-text-field solo :rules="requiredRule" v-model="PackageTitle" label="Package Title"></v-text-field>
                      </v-flex>
                      <v-flex xs12 lg2>
                        <v-select
                          :items="types"
                          label="Package Price Type"
                          solo
                          v-model="CostType"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 lg3 v-if="CostType=='cost'">
                        <v-text-field solo v-model="PackagePrice" type="number" :rules="requiredRule" label="Package Price"></v-text-field></v-flex>
                      <v-flex xs12 lg3 v-if="CostType=='cost'">
                        <v-text-field solo v-model="InternalPrice" type="number" :rules="requiredRule" label="Internal Price"></v-text-field></v-flex>
                      <v-flex xs12 lg12 v-if="CostType=='cost'">
                        <v-combobox solo :items="modules" item-text="name" item-value="id" @change="callMultiple"  :rules="requiredRule"
                                    v-model="selectedClasses" label="Select all classes" multiple chips>
                          <template slot="selection" slot-scope="data">
                            <v-chip outline
                                    :selected="data.selectedClasses"
                                    :disabled="data.disabled"
                                    :key="JSON.stringify(data.item)"
                                    class="v-chip--select-multi"
                                    @input="data.parent.selectItem(data.item)">
                              <v-avatar
                                class="accent white--text"
                               v-text="data.item.name.slice(0, 1).toUpperCase()"></v-avatar>{{ data.item.name }}</v-chip>
                          </template>
                        </v-combobox>

                        <v-combobox solo :items="selectedClasses" item-text="name" item-value="id" @change="callMultiple"  :rules="requiredRule"
                                    v-model="selectedFreeClasses" label="Select Free Classes" multiple chips>
                          <template slot="selection" slot-scope="data">
                            <v-chip outline
                                    :selected="data.selectedFreeClasses"
                                    :disabled="data.disabled"
                                    :key="JSON.stringify(data.item)"
                                    class="v-chip--select-multi"
                                    @input="data.parent.selectItem(data.item)">
                              <v-avatar
                                class="accent white--text"
                                v-text="data.item.name.slice(0, 1).toUpperCase()"></v-avatar>{{ data.item.name }}</v-chip>
                          </template>
                        </v-combobox>
                      </v-flex>


                      <v-flex xs12 lg12 v-if="CostType=='free'">
                        <v-combobox solo :items="modules" item-text="name"  item-value="id" @change="callMultiple"
                                    v-model="FreePackageFreeClasses" label="Select Free Classes" multiple chips>
                          <template slot="selection" slot-scope="data">
                            <v-chip outline
                                    :selected="data.selectedFreeClasses"
                                    :disabled="data.disabled"
                                    :key="JSON.stringify(data.item)"
                                    class="v-chip--select-multi"
                                    @input="data.parent.selectItem(data.item)">
                              <v-avatar
                                class="accent white--text"
                                v-text="data.item.name.slice(0, 1).toUpperCase()"></v-avatar>{{ data.item.name }}</v-chip>
                          </template>
                        </v-combobox>
                      </v-flex>
                      <!-- <v-flex xs12 lg12 v-if="CostType=='Custom'">
                        <v-combobox outline :items="items" item-text="" @change="callMultiple"  :rules="requiredRule"
                                    v-model="selectedClasses" label="Select Free Classes" multiple chips>
                          <template slot="selection" slot-scope="data">
                            <v-chip outline
                                    :selected="data.selectedClasses"
                                    :disabled="data.disabled"
                                    :key="JSON.stringify(data.item)"
                                    class="v-chip--select-multi"
                                    @input="data.parent.selectItem(data.item)">
                              <v-avatar
                                class="accent white--text"
                                v-text="data.item.slice(0, 1).toUpperCase()"></v-avatar>{{ data.item }}</v-chip>
                          </template>
                        </v-combobox>
                      </v-flex> -->

                      <!-- <v-flex xs12 lg12 v-if="CostType=='Free Upto three classes'">
                        <v-combobox outline :items="items" item-text="" @change="callMultiple"  :rules="requiredRule"
                                    v-model="selectedClasses" label="Select Classes by order" multiple chips>
                          <template slot="selection" slot-scope="data">
                            <v-chip outline
                                    :selected="data.selectedClasses"
                                    :disabled="data.disabled"
                                    :key="JSON.stringify(data.item)"
                                    class="v-chip--select-multi"
                                    @input="data.parent.selectItem(data.item)">
                              <v-avatar
                                class="accent white--text"
                                v-text="data.item.slice(0, 1).toUpperCase()"></v-avatar>{{ data.item }}</v-chip>
                          </template>
                        </v-combobox>
                      </v-flex> -->
                      <!-- <v-flex xs12 lg12 v-if="CostType=='After 3'">
                        <v-combobox outline :items="items" item-text="" @change="callMultiple"  :rules="requiredRule"
                                    v-model="selectedClasses" label="Select 3 Free Classes" multiple chips>
                          <template slot="selection" slot-scope="data">
                            <v-chip outline
                                    :selected="data.selectedClasses"
                                    :disabled="data.disabled"
                                    :key="JSON.stringify(data.item)"
                                    class="v-chip--select-multi"
                                    @input="data.parent.selectItem(data.item)">
                              <v-avatar
                                class="accent white--text"
                                v-text="data.item.slice(0, 1).toUpperCase()"></v-avatar>{{ data.item }}</v-chip>
                          </template>
                        </v-combobox>
                      </v-flex> -->

                      <!-- <v-flex xs12 lg12 v-if="CostType=='After 5'">
                        <v-combobox outline :items="items" item-text="" @change="callMultiple"  :rules="requiredRule"
                                    v-model="selectedClasses" label="Select pay Classes" multiple chips>
                          <template slot="selection" slot-scope="data">
                            <v-chip outline
                                    :selected="data.selectedClasses"
                                    :disabled="data.disabled"
                                    :key="JSON.stringify(data.item)"
                                    class="v-chip--select-multi"
                                    @input="data.parent.selectItem(data.item)">
                              <v-avatar
                                class="accent white--text"
                                v-text="data.item.slice(0, 1).toUpperCase()"></v-avatar>{{ data.item }}</v-chip>
                          </template>
                        </v-combobox>
                      </v-flex> -->
                      <!-- <v-flex xs12 lg12 v-if="CostType=='After 5'">
                        <v-combobox outline :items="items" item-text="" @change="callMultiple"  :rules="requiredRule"
                                    v-model="selectedClasses" label="Select 5 Free Classes" multiple chips>
                          <template slot="selection" slot-scope="data">
                            <v-chip outline
                                    :selected="data.selectedClasses"
                                    :disabled="data.disabled"
                                    :key="JSON.stringify(data.item)"
                                    class="v-chip--select-multi"
                                    @input="data.parent.selectItem(data.item)">
                              <v-avatar
                                class="accent white--text"
                                v-text="data.item.slice(0, 1).toUpperCase()"></v-avatar>{{ data.item }}</v-chip>
                          </template>
                        </v-combobox>
                      </v-flex> -->
                      <v-flex xs12 lg12 >
                        <v-textarea solo v-model="Description"  name="input-7-1" label="Description"></v-textarea>
                      </v-flex>
                      <v-flex xs12 lg12 class="text-xs-center">
                          <v-progress-circular
                              indeterminate
                              v-if=loading
                              color="primary"
                          ></v-progress-circular>
                          <v-alert
                            :value="true"
                            color="success"
                            icon="check_circle"
                            v-if="alert.type=='success'"
                            outline
                          >
                            {{alert.msg}}
                          </v-alert>
                          <v-alert
                            :value="true"
                            color="error"
                            icon="warning"
                            v-if="alert.type=='warning'"
                            outline
                          >
                            {{alert.msg}}
                          </v-alert>
                      </v-flex>
                      <v-flex lg12 xs12 class="text-xs-right">
                        <ConfirmSignup v-on:confirmyes="updatePackage" v-bind:value1="PackageTitle" v-bind:value2="PackagePrice"/>
                      </v-flex>
                    </v-layout>
    </v-card>
    </v-container>
</template>
<script>
  /* eslint-disable */
  import ConfirmSignup from "@/pages/auth/ConfirmSignup";
  import { mapState,dispatch } from 'vuex';
  import api from "@/utils/backend-api"
  export default {
    data: () => ({
      attachment: {
        photos: [],
        photosURL: [],
        videos: [],
        videosURL: []
      },
      PackageTitle:'',
      CostType:['free','cost'],
      PackagePrice:'',
      InternalPrice:'',
      Description:'',
      FreePackageFreeClasses:[],
      selectedClasses:[],
      selectedFreeClasses:[],
      module_id:[],
      free_modules:[],
      items: [],
      items1:[],
      newPackage: {
        typee: 'Pay',
        user: {
        },
      },
      types: ['free', 'cost'],
      // items1: [
      //   'Three Wheeler',
      //   'motor Bike',
      //   'Car',
      // ],
      loading:false,
      alert:{
        type:'',
        msg:''
      },
      requiredRule: [v => !!v || "This field is required"],
    }),
    watch: {},
    beforeCreate(){
      Store.dispatch('getAllClasses')
    },
    created:function(params){

      // Store.commit('setLoading', { loading: true })
      // Store.dispatch('Modules/getAllClasses')
      // Store.commit('setLoading', { loading: false })
        // Store.dispatch('Modules/getAllClasses')
      let self=this
      // api.postData('driver/viewModuleTemplate')
      // .then(res=>{
      //   debugger
      //   self.modules=res.data
      // })



      this.packId = this.$route.params.id;


      api.postData('driver/viewPackageTemplate/'+this.packId)
      // api.postData('driver/viewPackageTemplate',{package_id:this.packId})
        .then(res=>{
          self.PackageTitle=res.data.name
          self.CostType=res.data.price_type
          if(res.data.price_type=='cost'){

            self.selectedClasses=res.data.modules
            self.selectedFreeClasses=res.data.free_modules_data
            // function CheckPackId(packid){
            //   self.modules.filter(function(pack){
            //       if(pack.id==packid){
            //         return true
            //       }else{
            //         return false
            //       }
            //   })
            // }
            // self.selectedClasses=self.modules.filter(CheckPackId)
          }else if(res.data.price_type=='free'){
            self.FreePackageFreeClasses=res.data.modules
          }
          self.Description=res.data.description
          self.PackagePrice=res.data.cost
          self.InternalPrice=res.data.special_price
        })

                  // setTimeout(() => {
                  //   //debugger
                  //   for(var i=0;i<this.modules.length;i++){
                  //     for(var y=0;y<this.modules.length;y++){
                  //         // var id=this.modules[i].id
                  //         var name=this.modules[i].name
                  //         this.items.push(name)
                  //         var FreeNames=this.modules[y].name
                  //         this.items1.push(FreeNames)


                  //     }
                  //   }
                  //   // var id=this.modules[i].id
                  // }, 3000);


    },
    methods: {
      filterPackId(pack){
        return pack.id
      },
      updatePackage(){
          this.loading=true
          this.alert.type=""

          let selectedTotModulesId=[]
          let selectedFreeModulesId=[]
          let FreePackageFreeClassesId=[]

          this.selectedClasses.forEach(function(arr){
            selectedTotModulesId.push(arr.id)
          })
          this.selectedFreeClasses.forEach(function(arr){
            selectedFreeModulesId.push(arr.id)
          })
          this.FreePackageFreeClasses.forEach(function(arr){
            FreePackageFreeClassesId.push(arr.id)
          })

          console.log(selectedTotModulesId)
          var PackageDetails={
                'name':this.PackageTitle,
                'price_type':this.CostType,
                'description':this.Description,
                'module_id':this.CostType=='free'?FreePackageFreeClassesId:selectedTotModulesId,
                'free_modules':this.CostType=='free'?FreePackageFreeClassesId:selectedFreeModulesId,
                'cost':this.PackagePrice,
                'special_price':this.InternalPrice,
                'package_template_id':this.packId
          }
          api.postData('driver/updatePackageTemplate', PackageDetails)
          .then(res => {
            console.log(res)
            if(res.status==201){
              this.loading=false
              this.alert.type="success"
              this.alert.msg="Package created successfully"
              if(res.status==201){
                this.$router.push('/packages');
              }
            }
          }).catch(res=>{
              this.loading=false
              this.alert.type="warning"
              this.alert.msg="Package creation failed"
          })
          // Store.dispatch('Packages/createPackage',PackageDetails).then(res=>{
          //   console.log(res)
          //     if(res.status==201){
          //         // this.$router.push('/packages');
          //     }
          // }).catch(error=>{
          //   console.log(error)
          // })
      },
      callMultiple(){
        // debugger
        // this.ModuleNameToId()
        //this.packagePriceAutoCalculation()
      },
      ModuleNameToId() {
            this.module_id=[]
            this.free_modules=[]
            //debugger
            var ModuleList=Store.state.Modules.modules
            var Names=this.selectedClasses==''?[]:this.selectedClasses
            //var FreeModuleList=Store.state.Modules.freemodules
            //var allmodules=[]
            var FreeNames=this.selectedFreeClasses


          //var allmodules=Names.concat(FreeNames);
          for(let x=0;x<ModuleList.length;x++){
            for(var y=0;y<Names.length;y++){
                  if(Names[y]==ModuleList[x].name){
                    this.module_id.push(ModuleList[y].id)
                  }
            }
            for(var z=0;z<FreeNames.length;z++){
                  if(FreeNames[z]==ModuleList[x].name){
                    this.free_modules.push(ModuleList[x].id)

                  }
            }
          }

          // for(let x=0;x<ModuleList.length;x++){
          //   for(var y=0;y<FreeNames.length;y++){
          //         if(FreeNames[y]==ModuleList[x].name){
          //           debugger
          //           this.free_modules.push(ModuleList[x].id)

          //         }
          //   }
          // }

          console.log(this.module_id)
          console.log(this.free_modules)


             //console.log(ModuleList.length)
            // for(var i=0;i<Names.length;++i){
            //   // console.log
            //   for(var x=0;x<FreeNames.length;x++){
            //     // if(Names[i]==ModuleList[x].name){

            //   }
            //   debugger

            //       //this.module_id.push(ModuleList[x].id)
            //       for(var y=0;y<allmodules.length;y++){
            //         this.module_id.push(allmodules[y].id)
            //         //console.log(ModuleList.length)
            //       //  if(FreeNames[y]==ModuleList[y].name){
            //          //console.log(FreeNames)
            //         //this.module_id.push(ModuleList[x].id)
            //         console.log(allmodules)

            //       //  }

            //         // for(var z=0; z<allmodules.length; z++){
            //         // this.module_id.push(allmodules.id)
            //         // }

            //     }
            //     // }











            // }
      },

      // packagePriceAutoCalculation() {
      //       this.PackagePrice=''
      //       this.InternalPrice=''
      //       var ModuleList=Store.state.Modules.modules
      //       var Names=this.selectedClasses
      //       for(var i=0;i<Names.length;i++){
      //         for(var x=0;x<ModuleList.length;x++){
      //           if(Names[i]==ModuleList[x].name){
      //               this.PackagePrice=Number(this.PackagePrice)+Number(ModuleList[x].internal_price)
      //               this.InternalPrice=Number(this.InternalPrice)+Number(ModuleList[x].internal_price)
      //           }
      //         }
      //       }
      // },
      onPickImg(){
        this.$refs.ImgInput.click();
      },
      onImgPicked(){
        const files = event.target.files;
        let fileName = files[0].name;
        if (fileName.lastIndexOf(".") <= 0) {
          return alert("Please add a valid file! ");
        }
        const fileReader = new FileReader();
        fileReader.addEventListener("load", () => {
          this.attachment.photosURL.push(fileReader.result);

        });
        fileReader.readAsDataURL(files[0]);
        this.attachment.photos.push(files[0]);
      },

    },
    computed:{
      ...mapState ({
              modules:Modules => Store.state.modules,
              //freemodules:Modules => Store.state.Modules.freemodules
      })
    },
    components: {
      ConfirmSignup
    }
  };
</script>
<style>
  .v-dialog{
    box-shadow: none!important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/pages/package/EditPackage.vue